import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  srsInfoBanner: {
    display: 'flex',
    padding: '5px',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '4px',
    backgroundColor: theme.evPalette.charcoal[100],
  },
  srsInfoText: {
    padding: '8px',
    flex: '1 1 0',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    color: '#000000',
    textAlign: 'flex-start',
  },
}));
